import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import { BiGalleryVariant } from '../../functions/biGalleryTypes';
import { GalleryCard } from '../card/GalleryCard';

/** One variant: its name, what it sets, and its card. */
export const VariantCell = memo(
  ({
    variant,
    palette,
    width,
  }: {
    variant: BiGalleryVariant;
    palette: BiPalette;
    width: number;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ width, gap: rpx(6) }}>
        <View style={{ gap: rpx(2) }}>
          <Typography.Text medium size={rpx(13)} color={aiColors.foreground}>
            {variant.name}
          </Typography.Text>
          {variant.note ? (
            <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
              {variant.note}
            </Typography.Text>
          ) : null}
        </View>
        <GalleryCard card={variant.card} palette={palette} />
      </View>
    );
  },
);
